

/**
 * ACTIONS
 * @type {string}
 */
const INSERT_LIBRARIES = 'INSERT_LIBRARIES';
const LAYOUT_DATA_ACTION = 'LAYOUT_DATA_ACTION';
const LOADING_ACTION = 'LOADING_ACTION';
const SELECTED_LIBRARY_ACTION = 'SELECTED_LIBRARY_ACTION';
const SEARCH_TEXT_ACTION = 'SEARCH_TEXT_ACTION';
const SELECTED_CATEGORY_ID_ACTION = 'SELECTED_CATEGORY_ID_ACTION';
const SEARCH_RESULT_ACTION = 'SEARCH_RESULT_ACTION';
const LOADING_SEARCH_ACTION = 'LOADING_SEARCH_ACTION';
const PAGINATION_ACTION = 'PAGINATION_ACTION';
const CURRENT_PAGE_ACTION = 'CURRENT_PAGE_ACTION';
const INSERT_CATEGORIES = 'INSERT_CATEGORIES';
const INSERT_BREADCRUMB_ACTION = 'INSERT_BREADCRUMB_ACTION';
const INSERT_BREADCRUMB_LABEL_ACTION = 'INSERT_BREADCRUMB_LABEL_ACTION';
const CLEAR_BREADCRUMB_ACTION = 'CLEAR_BREADCRUMB_ACTION';
const GLOBAL_LOADING_ACTION = 'GLOBAL_LOADING_ACTION';
const DATA_ACCESS_FROM_VITRINE = 'DATA_ACCESS_FROM_VITRINE';
const DISPLAY_CATEGORIES = 'DISPLAY_CATEGORIES';
const SELECTED_CATEGORY_ACTION = 'SELECTED_CATEGORY_ACTION';
const RUN_SEARCH_ACTION = 'RUN_SEARCH_ACTION';
const NAVIGATE_BY_ACTION = 'NAVIGATE_BY_ACTION';
const PAGE_CODE_ACTION  = 'PAGE_CODE_ACTION';
const VITRINE_ACTION  = 'VITRINE_ACTION';
const BIBLIOTECA_TIPO_CATALOGO_KIDS = 'BIBLIOTECA_TIPO_CATALOGO_KIDS';
const CAPA_PADRAO_ACTION = 'CAPA_PADRAO_ACTION';
const LABELS_DADOS_ACERVO = 'LABELS_DADOS_ACERVO';
const PAGE_PREFIX =  'PAGE_PREFIX';
const LOADING_LIBRARIES = 'LOADING_LIBRARIES'
const CHANGE_LABELS = 'CHANGE_LABELS'
const TO_INITIAL_STATE = 'TO_INITIAL_STATE'
const CHANGE_LOADING_LABELS = 'CHANGE_LOADING_LABELS'
const LOADING_CATEGORIES = 'LOADING_CATEGORIES'

export const insertLibraries = payload => ({
    type: INSERT_LIBRARIES,
    payload,
});

export const layoutDataAction = payload => ({
    type: LAYOUT_DATA_ACTION,
    payload
})

export const loadingAction = payload => ({
    type: LOADING_ACTION,
    payload
})

export const selectedLibraryAction = payload => ({
    type: SELECTED_LIBRARY_ACTION,
    payload
})


export const searchTextAction = payload => ({
    type: SEARCH_TEXT_ACTION,
    payload
})

export const selectedCategoryIdAction = payload => ({
    type: SELECTED_CATEGORY_ID_ACTION,
    payload
})


export const searchResultAction = payload => ({
    type: SEARCH_RESULT_ACTION,
    payload
})

export const loadingSearchResultAction = payload => ({
    type: LOADING_SEARCH_ACTION,
    payload
})

export const paginationAction = payload => ({
    type: PAGINATION_ACTION,
    payload
})

export const currentPageAction = payload => ({
    type: CURRENT_PAGE_ACTION,
    payload
})

export const insertCategoriesAction = payload => ({
    type: INSERT_CATEGORIES,
    payload
})

export const insertBreadCrumbAction  = payload => ({
    type: INSERT_BREADCRUMB_ACTION,
    payload
})

export const changeBreadCrumbLabel  = payload => ({
    type: INSERT_BREADCRUMB_LABEL_ACTION,
    payload
})

export const clearBreadCrumbAction  = payload => ({
    type: CLEAR_BREADCRUMB_ACTION,
    payload
})

export const dataAccessFromVitrineAction = payload => ({
    type: DATA_ACCESS_FROM_VITRINE,
    payload,
});

export const displayCategoriesAction = payload => ({
    type: DISPLAY_CATEGORIES,
    payload,
});

export const selectedCategoryAction = payload => ({
    type: SELECTED_CATEGORY_ACTION,
    payload,
});

export const runSearchAction = payload => ({
    type: RUN_SEARCH_ACTION,
    payload,
});

export const navigateByAction = payload => ({
    type: NAVIGATE_BY_ACTION,
    payload,
});

export const pageCodeAction = payload => ({
    type: PAGE_CODE_ACTION,
    payload,
});

export const vitrineAction = payload => ({
    type: VITRINE_ACTION,
    payload,
});

export const bibliotecaTipoCatalogoKidsAction = payload => ({
    type: BIBLIOTECA_TIPO_CATALOGO_KIDS,
    payload,
});


/**
 *
 * @param payload {{librariesSection: boolean,
 *                  categoriesSection: boolean,
 *                  centralContent: boolean,
 *                  noticesSection: boolean,
 *                  searchSection: boolean}}
 * @returns {{payload, type: string}}
 */
export const changeGlobalLoading = payload => ({
    type: GLOBAL_LOADING_ACTION,
    payload
})


export const changeCapaPadrao = payload => ({
    type: CAPA_PADRAO_ACTION,
    payload
})

export const changeLabelsDadosAcervo = payload => ({
    type: LABELS_DADOS_ACERVO,
    payload
})

export const changePagePrefix = payload => ({
    type: PAGE_PREFIX,
    payload
})

export const loadingLibrariesAction = payload => ({
    type: LOADING_LIBRARIES,
    payload
})

export const changeLabelsAction = payload => ({
    type: CHANGE_LABELS,
    payload
})

export const changeLoadingLabels = payload => ({
    type: CHANGE_LOADING_LABELS,
    payload
})

export const toInitialState = payload => ({
    type: TO_INITIAL_STATE,
    payload
})

export const changeLoadingCategories = payload => ({
    type: LOADING_CATEGORIES,
    payload
})



/**
 * Initial state
 * @type {{libraries: *[]}}
 */
const INITIAL_STATE = {
    categories: null,
    selectedCategory: null,
    displayCategories:  null,
    libraries: null,
    layoutData:  null,
    loading: false,
    selectedLibraryId: 0,
    searchText: null,
    runSearch:  false,
    selectedCategoryId: 0,
    searchResult: [],
    loadingSearchResult: false,
    pagination: {
        currentPage: 0,
        perPage: 0,
        totalItems: 0
    },
    currentPage: 1,
    breadCrumbProps: {
        backButtonLabel: null,
        breadCrumbImage: null,
        breadCrumbColor: null,
        breadCrumbLabel: [],
        onClickBack: () => {},
        onClickGoHome: () => {
            window.location.replace('/catalogos/kids')
        }
    },
    globalLoading: {
        librariesSection: false,
        categoriesSection: false,
        centralContent: false,
        noticesSection: false,
        searchSection: false
    },
    dataAccessFromVitrine: false,
    navigateBy: null,
    pageCode: null,
    vitrine: null,
    bibliotecaTipoCatalogoKids: null,
    capaPadrao: null,
    labelsDadosAcervo: null,
    pagePrefix: null,
    loadingLibraries: false,
    labels: {},
    loadingLabels: false,
    loadingCategories: false
}

/**
 * Reducers
 * @param state
 * @param action
 * @returns {{libraries}|{libraries: *[]}}
 */
const pergamumKids = (state = INITIAL_STATE, action) => {
    const { type, payload } = action;

    switch (type) {
        case INSERT_LIBRARIES:
            return { ...state, libraries: payload };
        case LAYOUT_DATA_ACTION:
            return { ...state, layoutData: payload };
        case LOADING_ACTION:
            return { ...state, loading: payload };
        case SELECTED_LIBRARY_ACTION:
            return { ...state, selectedLibraryId: payload, layoutData: null, categories: null };
        case SEARCH_TEXT_ACTION:
            return { ...state, searchText: payload };
        case SELECTED_CATEGORY_ID_ACTION:
            return { ...state, selectedCategoryId: payload };
        case SEARCH_RESULT_ACTION:
            return { ...state, searchResult: payload };
        case LOADING_SEARCH_ACTION:
            return { ...state, loadingSearchResult: payload };
        case PAGINATION_ACTION:
            return { ...state, pagination: payload };
        case CURRENT_PAGE_ACTION:
            return { ...state, currentPage: payload };
        case INSERT_CATEGORIES:
            return { ...state, categories: payload };
        case INSERT_BREADCRUMB_ACTION:
            return { ...state, breadCrumbProps: payload };
        case CLEAR_BREADCRUMB_ACTION:
            return { ...state, breadCrumbProps: {
                    backButtonLabel: null,
                    breadCrumbImage: null,
                    breadCrumbLabel: [],
                    onClickBack: null,
                    onClickGoHome: null
                }};

        case INSERT_BREADCRUMB_LABEL_ACTION: {
           return {
               ...state,
               breadCrumbProps: {
                   ...state.breadCrumbProps,
                   breadCrumbLabel: payload
               }
           }
        }

        case GLOBAL_LOADING_ACTION: {
            return {
                ...state,
                globalLoading: {
                    ...state.globalLoading,
                    ...payload
                }
            }
        }

        case DATA_ACCESS_FROM_VITRINE:
            return { ...state, dataAccessFromVitrine: payload };
        case DISPLAY_CATEGORIES:
            return { ...state, displayCategories: payload };
        case SELECTED_CATEGORY_ACTION:
            return { ...state, selectedCategory: payload };
        case RUN_SEARCH_ACTION:
            return { ...state, runSearch: payload };
        case NAVIGATE_BY_ACTION:
            return { ...state, navigateBy: payload };
        case PAGE_CODE_ACTION:
            return { ...state, pageCode: payload };
        case VITRINE_ACTION:
            return { ...state, vitrine: payload };
        case BIBLIOTECA_TIPO_CATALOGO_KIDS:
            return { ...state, bibliotecaTipoCatalogoKids: payload };
        case CAPA_PADRAO_ACTION:
            return { ...state, capaPadrao: payload };
        case LABELS_DADOS_ACERVO:
            return { ...state, labelsDadosAcervo: payload };
        case PAGE_PREFIX:
            return { ...state, pagePrefix: payload };
        case LOADING_LIBRARIES:
            return { ...state, loadingLibraries: payload };
        case CHANGE_LABELS:
            return { ...state, labels: payload };
        case TO_INITIAL_STATE:
            return INITIAL_STATE;
        case CHANGE_LOADING_LABELS:
            return { ...state, loadingLabels: payload };
        case LOADING_CATEGORIES:
            return { ...state, loadingCategories: payload };
        default:
            return state;
    }
}

export default pergamumKids;
